import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import P from '../assets/P.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setIsMenuOpen(false);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogoClick = () => {
    navigate('/');
    if (isMobile) setIsMenuOpen(false);
  };

  const navLinks = [
    { path: "/works", text: "Our Works" },
    { path: "/success", text: "Success Story" },
    { path: "/testimonials", text: "Customer Testimonials" },
    { path: "/about", text: "About Us" }
  ];

  return (
    <header className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 py-4 md:py-6 lg:py-8">
      <nav className="flex items-center justify-between max-w-screen-2xl mx-auto">
        <div className="flex items-center space-x-6 lg:space-x-8 xl:space-x-12">
          {/* Logo - Made larger on mobile */}
          <button 
            onClick={handleLogoClick}
            className="bg-white rounded-lg p-2 md:p-3 lg:p-4 flex items-center justify-center focus:outline-none"
            aria-label="Home"
          >
            <img 
              src={P} 
              alt="Payan Design Studio Logo" 
              className="w-10 h-8 md:w-8 md:h-6 lg:w-10 lg:h-7 xl:w-12 xl:h-8"
            />
          </button>

          {/* About Us link - Desktop only */}
          {!isMobile && navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) => 
                `text-white hover:text-gray-300 transition-colors text-lg lg:text-xl xl:text-2xl capitalize
                ${isActive ? 'border-b-2 border-purple-500' : ''}`
              }
              style={{ fontFamily: 'Space Grotesk' }}
            >
              {link.text}
            </NavLink>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white focus:outline-none z-20"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Navigation Links - Mobile */}
        <div 
          className={`fixed md:hidden top-0 left-0 right-0 h-screen w-full bg-black z-10 transition-transform duration-300 ease-in-out
            ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
            flex flex-col items-center justify-center space-y-8 pt-0`}
        >
          {/* Mobile Logo - Made larger */}
          <button 
            onClick={handleLogoClick}
            className="focus:outline-none"
            aria-label="Home"
          >
            <div className="bg-white rounded-lg p-4 flex items-center justify-center">
              <img 
                src={P} 
                alt="Payan Design Studio Logo" 
                className="w-12 h-10"
              />
            </div>
          </button>

          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) => 
                `text-white hover:text-gray-300 transition-colors text-xl px-8 capitalize
                ${isActive ? 'border-b-2 border-purple-500' : ''}`
              }
              style={{ fontFamily: 'Space Grotesk' }}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.text}
            </NavLink>
          ))}

          <button 
            className="bg-purple-600 hover:bg-purple-700 transition-colors text-white rounded-lg px-8 py-4 mt-4"
            style={{
              background: 'rgba(111, 67, 254, 1)',
                width:'254px',
            height:'68px',
              fontFamily: 'Space Grotesk',
              fontWeight: '700'
            }}
            onClick={() => {
  setIsMenuOpen(false);
  window.open('https://cal.com/payandesign/workwithus', '_blank')
}}
          >
            <span className="text-lg capitalize">Work With Us</span>
          </button>
        </div>

        <button 
          className="hidden md:block bg-purple-600 hover:bg-purple-700 transition-colors text-white rounded-lg px-4 py-2 lg:px-6 lg:py-3 xl:px-8 xl:py-4"
          style={{
            background: 'rgba(111, 67, 254, 1)',
              width:'236px',
            height:'80px',  
            fontFamily: 'Space Grotesk',
            fontWeight: '700'
          }}
           onClick={() => window.open('https://cal.com/payandesign/workwithus', '_blank')}
        >
          <span style={{fontSize: '22px'}} className="text-sm lg:text-base xl:text-lg 2xl:text-xl capitalize">
            Work With Us
          </span>
        </button>
      </nav>
    </header>
  );
};

export default Header;